// TODO fix the following error
// eslint-disable-next-line import/prefer-default-export
export function parseError(errorResponse) {
  let error = {}
  Object.keys(errorResponse).forEach((field) => {
    error = { ...error, [field]: Object.values(errorResponse[field]) }
  })
  return error
}
